<template>
  <Modal size="lg">
    <div class="modal-header">{{ "reserve_order" | translate }}</div>
    <div class="modal-body">
      <pre>format:
        vendor
        comment
        order#|quantity|account $amount|account $amount|...
        order#|quantity|account $amount|account $amount|...</pre>
      <div class="alert alert-warning" v-if="validationError">{{ validationError }}</div>
      <textarea name="batchReserveOrder" id="" rows="20" class="form-control font-mono" v-model="content"></textarea>
    </div>

    <div class="modal-footer">
      <button class="btn btn-secondary" @click="cancel">{{ "cancel" | translate }}</button>
      <button class="btn btn-primary" @click="save">{{ "save" | translate }}</button>
    </div>
  </Modal>
</template>

<script>
const DIVIDER = "|"
const SUBDIVIDER = " "
const EXISTING_ORDER_PREFIX = '^^'
const MIN_LINES = 3
const LINE_VENDOR = 0
const LINE_COMMENT = 1
const LINE_ORDER_START = 2
export default {
  props: ["editingItem"],
  data() {
    return {
      validationError: null,
      content: null
    };
  },
  created() {},
  methods: {
    cancel() {
      this.$emit("dismiss");
    },
    save() {
      let orderItems = this._parseContent(this.content)
      this.$emit('close', orderItems)
    },
    fillRemaining(payment) {
      payment.amount = 0;
    },

    assert(value, message) {
      if (!value) {
        this.validationError = message;
        throw new Error("validation failed: " + message);
      }
      this.validationError = null;
    },

    _parseContent(content) {
      let lines = content.split("\n");
      if (lines.length < MIN_LINES) {
        this.assert(lines.length >= MIN_LINES, 'batch purchase order items content must follow format')
      }

      // line 0
      let vendor = lines[LINE_VENDOR].trim()
      this.assert(vendor.length > 0, 'vendor is required')

      // line 1
      let comment = lines[LINE_COMMENT].trim()

      // line 2+
      let orderItems = []
      for (let i = LINE_ORDER_START; i < lines.length; i++) {
        let line = lines[i].trim()
      
        // for empty line
        if (line.length < 2) continue

        // for ^^ existing order
        if (line.substr(0, 2) == EXISTING_ORDER_PREFIX) {
          this._parseExistingOrder(line, orderItems)
          continue
        }

        // for general order
        let order = {
          vendor,
          comment,
          ... this._parseOrder(line)
        }
        orderItems.push(order)
      }

      this.assert(orderItems.length >= 1, 'no reserve order found')
      
      return orderItems
    },

    _parseExistingOrder(line, orderItems) {
      let orderParts = line.split(DIVIDER)
      let orderNum = orderParts[0].substr(2)
      let quantity = parseFloat(orderParts[1])
      let processed = false
      for (let j = 0; j < orderItems.length; j++) {
        if (orderItems[j].orderNumber == orderNum) {
          orderItems[j].quantity += quantity
          processed = true
        }
      }
      if (!processed) {
        this.assert(false, `${orderNum} not found`)
      }
    },
    _parseOrder(line) {
      let orderParts = line.split(DIVIDER)
      let orderNum = orderParts[0].trim()
      this.assert(orderNum.length > 0, 'order number is required')

      let quantity = parseFloat(orderParts[1])
      if (isNaN(quantity)) {
        this.assert(false, 'quantity is required')
      }

      let payments = []
      let total = 0
      for (let k = 2; k < orderParts.length; k ++) {
        let paymentParts = orderParts[k].split(SUBDIVIDER)
        this.assert(paymentParts.length >= 2, 'payment must have account and amount, amount must have current symbol')

        let account = paymentParts[0].trim()
        this.assert(account.length > 0, 'acount is required')
        
        let currency = paymentParts[1][0] == '¥' ? 'cny' : 'usd'
        let amount = parseFloat(paymentParts[1].substr(1))
        total += amount
        payments.push({
          account,
          amount,
          currency
        })
      }
      return {
        currency: payments[0].currency,
        quantity: quantity,
        amount: total,
        orderNumber: orderNum,
        payments: payments,
        timestamp: new Date().getTime(),
      }
    }
  },
  components: {},
};

</script>
